export { View as Tab2017 } from './view'
